<template>
  <search-service
    :results="studentServices"
    :on-select-navigate="onSelectNavigateHandler"
    @search="onSearchHandler"
  />
</template>

<script>
import { SearchService } from 'compensatory-service';
import { getStudentServices } from '@/modules/compensatory-service/api';
import compensatoryRequestTypes from '@/utils/constants/compensatoryRequestTypes';

export default {
  name: 'SearchServiceWrapper',
  components: {
    SearchService,
  },
  data() {
    return {
      studentServices: [],
    };
  },
  methods: {
    onSelectNavigateHandler(item) {
      this.$router.push({
        name: 'CompensatoryRequest',
        params: {
          ...item,
          ...this.$route.params,
        },
      });
    },
    async onSearchHandler(search) {
      const compensatoryRequestType = this.$route.params.isReposition
        ? compensatoryRequestTypes.Reposicion
        : compensatoryRequestTypes.Regresion;
      const { data } = await getStudentServices(
        compensatoryRequestType,
        search
      );
      this.studentServices = data;
    },
  },
};
</script>
